import React from "react";
import { HandPlatter, Motorbike, Store } from "lucide-react";
import Tooltip from "./Tooltip";

export interface OrderTypeMeta {
  label: string;
  className: string;
  icon: React.ReactNode;
  ariaLabel: string;
}

export function getOrderTypeMeta(
  orderType?: string | null,
  iconSize = 14
): OrderTypeMeta | null {
  if (!orderType) return null;
  const normalized = orderType.toLowerCase().trim();

  if (normalized === "delivery") {
    return {
      label: "Entrega",
      className: "bg-blue-100 text-blue-800 border border-blue-200",
      icon: <Motorbike size={iconSize} />,
      ariaLabel: "Entrega",
    };
  }

  if (normalized === "takeout" || normalized === "pickup") {
    return {
      label: "Balcão/Retirada",
      className: "bg-violet-100 text-violet-800 border border-violet-200",
      icon: <HandPlatter size={iconSize} />,
      ariaLabel: "Balcão/Retirada",
    };
  }

  if (normalized === "indoor" || normalized === "dine_in") {
    return {
      label: "No salão",
      className: "bg-amber-100 text-amber-900 border border-amber-200",
      icon: <Store size={iconSize} />,
      ariaLabel: "Pedido no salão",
    };
  }

  return null;
}

interface OrderTypeBadgeProps {
  orderType?: string | null;
  iconSize?: number;
  className?: string;
  withTooltip?: boolean;
}

export const OrderTypeBadge: React.FC<OrderTypeBadgeProps> = ({
  orderType,
  iconSize = 14,
  className = "",
  withTooltip = true,
}) => {
  const meta = getOrderTypeMeta(orderType, iconSize);
  if (!meta) return null;

  const inner = (
    <span
      className={`inline-flex w-fit shrink-0 items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-semibold ${meta.className} ${className}`}
      aria-label={meta.ariaLabel}
    >
      {meta.icon}
      {meta.label}
    </span>
  );

  if (!withTooltip) return inner;

  return (
    <Tooltip text={meta.ariaLabel} position="top">
      {inner}
    </Tooltip>
  );
};
